var React = require('react');

function Twitter (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Twitter"),React.createElement("path",{"d":"M9.026 19c6.03 0 9.33-5.387 9.33-10.058 0-.26.181-.492.415-.6.803-.37 1.844-1.383.769-3.086-.712.389-1.298.601-2.082.858-1.241-1.423-3.319-1.492-4.64-.153-.85.863-1.212 2.15-.948 3.377-2.636-.142-5.723-2.114-7.388-4.322-.87 1.615-.426 3.681 1.015 4.72a3.08 3.08 0 0 1-1.488-.443v.045c0 1.683 1.1 3.131 2.63 3.465a3.04 3.04 0 0 1-1.48.06c.43 1.44 2.29 3.056 3.694 3.084-1.162.984-2.596 1.518-4.073 1.517-.26-.001-.52-.018-.78-.051a8.799 8.799 0 0 0 5.026 1.584V19z","fill":"currentColor","fillRule":"evenodd","key":1})]);
}

Twitter.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Twitter;

Twitter.default = Twitter;
